export enum StradiaRoutes {
  TRIPS = 'trips',
  MAP = 'map',
  IMAGE = 'image',
  LOGIN = 'login',
  EXPORT = 'export',
  DEVICE_CONFIG = 'device-config',
}
